<ng-container *transloco="let t">
  <div class="container top-spacing" aria-labelledby="student-profile-payments-tab" id="payments-and-grants" role="tabpanel" tabindex="0">
    <h2 class="sis-mt-md sis-mb-md">{{ t('PROFILE.PAYMENTS_AND_GRANTS.TAB_TITLE') }}</h2>
    <sis-tab-navigation [type]="'pills'" [tabs]="tabs"></sis-tab-navigation>
    <ui-view></ui-view>
  </div>
  </ng-container>
